import { render, staticRenderFns } from "./TheNewsModal.vue?vue&type=template&id=f3fc0a7c"
import script from "./TheNewsModal.vue?vue&type=script&lang=js"
export * from "./TheNewsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports